import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// import { sendQuoteCreateQuote } from '@om/redux/actions/sizotsaFuneralCover/quote';
// import { toggleQuoteCallMeBack } from '@om/redux/actions/sizotsaFuneralCover/callMeBack';
// import { getQuoteSummary } from '@om/redux/selectors/sizotsaFuneralCover/quote';
// import { OmIcon } from '@om/component-library-react';
// import OmButton from '../../../components/forms/OmButton';
import { navigateToReplacementPolicy } from '@om/redux/actions/sizotsaFuneralCover/routing';

import './BwQuoteSummaryCard.scss';
import OmButton from '../../../../components/forms/OmButton';
import { SF_COVER_CATEGORIES, PAGES } from '@om/redux/actions/sizotsaFuneralCover/types';
import { navigate } from 'gatsby';
import { getFinalQuotation, getLivesCovered, getQuoteResponse, getValueWithThousandSeperator } from '@om/redux/selectors/sizotsaFuneralCover/quote';
import { setQuoteDrawerValue } from '@om/redux/actions/sizotsaFuneralCover/quote';
import { setLeadSystem, setPrivacyPolicyURLValue, setProductNameValue } from '@om/redux/actions/publicWeb/callMeBack';
import { sendLeadsMail } from '@om/redux/actions/sizotsaFuneralCover/policyRequest';


const BwQuoteSummaryCard = ({ isSticky, name, withoutbuttons ,isBuyNowDisabled}) => {
    const dispatch = useDispatch();
    const { quoteSummary, livesCovered,quotingResponse } = useSelector(
        createStructuredSelector({
            quoteSummary: getFinalQuotation,
            livesCovered: getLivesCovered,
            quotingResponse:getQuoteResponse
        })
    );
    const {funeralPremium=0}= quotingResponse
    // const coverAmount = JSON.parse(quoteSummary.categoryAmounts);
    // const coverCat = JSON.parse(quoteSummary.categories);
    // const totalQuoting = coverAmount?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const [isExpanded, setIsExpanded] = useState(withoutbuttons);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    return (
        <>
            <div className="sticky-summary-card-wrapper FuneralQuotingSummary">
                <div className="heading-group" >
                    <div className="group-left">
                        <p className="summary-heading">Quote summary</p>
                    </div>
                    {!withoutbuttons && <div className="group-right">
                        <strong >E {funeralPremium} PM</strong>
                        <br/>
                        <strong >E {(getValueWithThousandSeperator((funeralPremium*12)?.toFixed(2)))} PA</strong>
                    </div>}
                    {/* <div className='heading-wrapper'>
                        <h4 className="heading-total-text">P{totalQuoting} p/m</h4>
                        <OmIcon iconName={`${isExpanded ? 'expand_less' : 'expand_more'}`} />
                    </div> */}
                </div>
                {withoutbuttons && <div className={`content ${isExpanded ? 'card-contents expanded' : 'card-contents'}`}>
                    <div className="selectable-container">

                        <div className="family-group" >
                            <p className="family-text">Here is your total funeral cover cost:
                            </p>
                            <p className="family-cover-amount">E {funeralPremium} PM <br></br>E {getValueWithThousandSeperator((funeralPremium*12)?.toFixed(2))} PA</p>
                            <br/>
                        </div>

                    </div>
                </div>}
                {!withoutbuttons && <div className="footer-group purchase">
                    <h6 className="button-text">Are you ready to purchase Sizotsa funeral cover?</h6>
                    <div className="button-container">
                        <div className="left">
                            <OmButton
                                size="small"
                                type="secondary"
                                text="CALL ME BACK"
                                actionObject={ {
                                    __typename: 'Contentstack_call_me_back_email',
                                    call_me_back_product: 'Sizotsa funeral cover',
                                    email: "tdejesussargo@oldmutual.com",
                                    privacy_policy_url: '/about-old-mutual/privacy-policy/'
                                }}
                                onClick={() => {
                                    dispatch(setLeadSystem('sz'))
                                    dispatch(setPrivacyPolicyURLValue('/privacy-notice/'))
                                    dispatch(setProductNameValue('Sizotsa Funeral Cover'))

                                }}
                            />
                            
                        </div>
                        <div className="right">
                            <OmButton
                                type='primary'
                                size='small'
                                text="Buy Now"
                                disabled={!isBuyNowDisabled}
                                onClick={() => {
                                   
                                    if (Object.keys(livesCovered[SF_COVER_CATEGORIES.AGENT]).length) {
                                        dispatch(navigateToReplacementPolicy())
                                        navigate(PAGES[0].URL);
                                    } else {
                                        dispatch(sendLeadsMail())
                                        dispatch(setQuoteDrawerValue({
                                            fieldType: 'coverType',
                                            value: SF_COVER_CATEGORIES.AGENT,
                                        }))
                                    }

                                }}>

                            </OmButton>
                        </div>
                    </div>
                </div>}
            </div>
        </>
    );
};

export default BwQuoteSummaryCard;
